import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1de80f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { class: "form-dynamic-row form-group-col-1" }
const _hoisted_5 = { class: "form-dynamic-row form-group-col-2" }
const _hoisted_6 = { class: "form-dynamic-row form-group-col-2" }
const _hoisted_7 = { class: "operations-wrap" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_select_option = _resolveComponent("select-option")!
  const _component_password_field = _resolveComponent("password-field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "modal_mask",
        onMousedown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal($event))),
        class: "modal-mask"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            id: "close-modal",
            to: { name: 'users' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'times'] })
            ]),
            _: 1
          }),
          _createElementVNode("h1", _hoisted_2, _toDisplayString(!_ctx.user_id ? "Cadastro " : "") + "Profissional ", 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Form, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_text_field, {
                    modelValue: _ctx.body.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.body.name) = $event)),
                    name: 'name',
                    label: 'Nome',
                    validators: { required: {} },
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "onUpdateValidation"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_text_field, {
                    modelValue: _ctx.body.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.body.email) = $event)),
                    name: 'email',
                    label: 'E-mail',
                    validators: { required: {}, email: {} },
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "onUpdateValidation"]),
                  _createVNode(_component_select_option, {
                    name: 'clinic',
                    label: 'Seleciona estabelecimento',
                    required: true,
                    options: _ctx.select_options.clinics,
                    empty_message: 'Cadastre uma clínica',
                    modelValue: _ctx.body.clinic_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body.clinic_id) = $event)),
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["options", "modelValue", "onUpdateValidation"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_text_field, {
                    name: 'username',
                    label: 'Nome de usuário',
                    modelValue: _ctx.body.username,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.body.username) = $event)),
                    format: 'username',
                    validators: { required: {} },
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "onUpdateValidation"]),
                  _createVNode(_component_password_field, {
                    name: 'password',
                    label: 'Senha',
                    modelValue: _ctx.body.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.body.password) = $event)),
                    onUpdateValidation: _ctx.updateValidation
                  }, null, 8, ["modelValue", "onUpdateValidation"])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save())),
              class: _normalizeClass({
              btn: true,
              'btn-update': !_ctx.isLoading && _ctx.isFormValid && !!_ctx.user_id,
              'btn-new': !_ctx.isLoading && _ctx.isFormValid && !!!_ctx.user_id,
            }),
              disabled: !_ctx.isFormValid || _ctx.isLoading
            }, " Salvar ", 10, _hoisted_8)
          ])
        ])
      ], 544)
    ]),
    _: 1
  }))
}